import { __decorate } from "tslib";
import { ValidatorConstraint } from 'class-validator';
export const LATIN_EXTENDED_REGEXP_NAMES = /[^a-zA-Z0-9&\-'".,\u00C0-\u024F\u1E00-\u1EFF\s]+/g;
/**
 * Allowing quotes, full stops and dashes for user's names e.g. O'shannasay or A.B. Somewhere, etc
 * Include Latin A/B, Latin Extended Additional for cases such as naïve.
 * @see https://stackoverflow.com/questions/20690499/concrete-javascript-regex-for-accented-characters-diacritics
 * @see https://github.com/typestack/class-validator#custom-validation-classes
 */
let IsLatinExtendedName = class IsLatinExtendedName {
    validate(value) {
        if (value && !value.trim()) {
            return false;
        }
        return !(value && value.trim().match(LATIN_EXTENDED_REGEXP_NAMES));
    }
    defaultMessage() {
        return '$value contains invalid characters';
    }
};
IsLatinExtendedName = __decorate([
    ValidatorConstraint({ name: 'latinExtendedName', async: false })
], IsLatinExtendedName);
export { IsLatinExtendedName };
